export function detectBody() {
    const bodyClass = document.body.classList;

    if (document.body.clientWidth < 769) {
        bodyClass.toggle('body-small', true);
    } else {
        document.body.classList.toggle('body-small', false);
    }
}

export function smoothlyMenu() {
    const bodyClass = document.body.classList;
    const sideMenu = document.getElementById('side-menu');

    if(![...bodyClass].includes('mini-navbar') || [...bodyClass].includes('body-small')) {
        sideMenu.style.opacity = '0';
        setTimeout( () => {
            sideMenu.style.opacity = '1';
            sideMenu.style.transition = '0.4s ease-in';
        }, 200);
    } else if ([...bodyClass].includes('fixed-sidebar')) {
        sideMenu.style.opacity = '0';
        setTimeout( () => {
            sideMenu.style.opacity = '1';
            sideMenu.style.transition = '0.4s ease-in';
        }, 100);
    } else {
        sideMenu.removeAttribute('style');
    }
}

export function getHeight(element) {
    element.style.height = 'auto';
    const elHeight = element.offsetHeight;
    element.style.height = '0';
    return elHeight;
}

export function openSubmenu(element) {
    const elementHeight = getHeight(element);
    setTimeout(() => element.style.height = elementHeight + 'px', 1);
    return 'active';
}

export function closeSubmenu(element) {
    element.style.height = '0';
    return '';
}


// WEBPACK FOOTER //
// ./src/components/common/LayoutHelpers.js